import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { CloseIcon } from 'icons';
import { colors } from '../../styles/colors';
import { CloseButtonWrapper } from './styles';

interface ModalCloseButtonProps {
  onClick: () => void;
  iconColor?: string;
  iconSize?: string;
  className?: string;
}

export function ModalCloseButton({
  onClick, iconColor = colors.Grey400, iconSize = '12px', className,
}: Readonly<ModalCloseButtonProps>): ReactElement {
  const { t } = useTranslation();

  return (
    <CloseButtonWrapper type="button" aria-label={t('fechar')} onClick={onClick} className={className}>
      <CloseIcon color={iconColor} size={iconSize} />
    </CloseButtonWrapper>
  );
}
